/**
 * @global {Object.<string, number>} abConfig
 */

import { bootstrapConfirm } from './helpers';

const collectDebugData = () => {
    try {
        return {
            timeOpened: new Date(),
            timezone: (new Date()).getTimezoneOffset() / 60,

            pageon: window.location.pathname,
            referrer: document.referrer,

            browserName: navigator.appName,
            browserEngine: navigator.product,
            browserVersion1a: navigator.appVersion,
            browserVersion1b: navigator.userAgent,
            browserLanguage: navigator.language,
            browserOnline: navigator.onLine,
            browserPlatform: navigator.platform,
            javaEnabled: navigator.javaEnabled(),
            dataCookiesEnabled: navigator.cookieEnabled,
            connectionDownlink: navigator.connection.downlink,
            connectionEffectiveType: navigator.connection.effectiveType,
            connectionRtt: navigator.connection.rtt,
            connectionSaveData: navigator.connection.saveData,
            connectionType: navigator.connection.type,

            sizeScreenW: screen.width,
            sizeScreenH: screen.height,
            sizeDocW: document.width,
            sizeDocH: document.height,
            sizeInW: innerWidth,
            sizeInH: innerHeight,
            sizeAvailW: screen.availWidth,
            sizeAvailH: screen.availHeight,
            scrColorDepth: screen.colorDepth,
            scrPixelDepth: screen.pixelDepth,
        };
    } catch (error) {
        return {};
    }
};

const setInputError = (code, message = '') => {
    let formGroup = document.querySelector(`[data-field-group="${code}"]`);

    if (!formGroup) {
        let input = document.getElementById(code);
        if (!input) {
            input = document.querySelector(`[name="${code}"]`);
        }

        if (input) {
            formGroup = input.parentNode.closest('.form-group');
        }
    }

    if (!formGroup) {
        return;
    }

    formGroup.classList.add('is-invalid');

    let inputFeedback = formGroup.querySelector('.invalid-feedback');

    if (!inputFeedback) {
        inputFeedback = document.createElement('div');
        inputFeedback.classList.add('invalid-feedback', 'small');

        formGroup.append(inputFeedback);
    }

    inputFeedback.innerHTML = message || 'Заполните это поле';
};

const cleanUpResponseData = (data) => {
    // eslint-disable-next-line no-param-reassign
    delete data.trigger;
    // eslint-disable-next-line no-param-reassign
    delete data.message;
    // eslint-disable-next-line no-param-reassign
    delete data.url;

    return data;
};

const showFormError = () => {

}

const initAjaxForms = () => {
    document.querySelectorAll('form[data-ajax]')
        .forEach((form) => {
            const button = form.querySelector('button[type=submit]');
            form.dataset.processed = '1';

            form.addEventListener('submit', (e) => {
                e.preventDefault();

                form.noValidate = true;
                button.disabled = true;

                form.querySelectorAll('.is-invalid')
                    .forEach((invalidator) => {
                        invalidator.classList.remove('is-invalid');
                    });

                const formData = new FormData(form);

                /**
                 * @typedef {Object} abConfig
                 * @property {String} bitrix_sessid
                 */
                // eslint-disable-next-line no-undef
                formData.append('sessid', abConfig.bitrix_sessid);

                if ('saveDebug' in form.dataset) {
                    formData.append('debug', JSON.stringify(collectDebugData()));
                }

                let method = form.dataset.method || 'POST';
                method = method.toUpperCase();

                if (method === 'PATCH' || method === 'PUT') {
                    formData.append('_METHOD', method);
                    method = 'POST';
                }

                const request = new XMLHttpRequest();
                request.open(method, form.dataset.ajax, true);
                request.send(formData);

                // eslint-disable-next-line func-names
                request.onreadystatechange = () => {
                    if (request.readyState === XMLHttpRequest.DONE) {
                        const response = request.responseText ? JSON.parse(request.responseText) : {};

                        console.log(response);
                        /**
                         * @typedef {Object} response
                         * @property {String} message
                         * @property {Array} fields
                         */
                        if (request.status === 0 || (request.status >= 200 && request.status < 400)) {
                            // redirect
                            if ('redirect' in form.dataset) {
                                let { redirect } = form.dataset;
                                Object.keys(response)
                                    .forEach((key) => {
                                        redirect = redirect.replace(`{${key}}`, response[key]);
                                    });
                                window.location = redirect;
                            }

                            // show message
                            if ('message' in form.dataset) {
                                (async () => {
                                    await bootstrapConfirm({
                                        message: form.dataset.message,
                                        type: 'success',
                                        button: 'закрыть',
                                    });
                                })();
                            }

                            // trigger event
                            if ('trigger' in form.dataset) {
                                document.dispatchEvent(new CustomEvent(form.dataset.trigger, {
                                    detail: cleanUpResponseData(response),
                                }));
                            }

                            // reset form
                            if ('reset' in form.dataset) {
                                form.reset();
                            }
                        } /*else if (this.status === 422 && typeof response.fields !== 'undefined') {
                            // Request fields error
                            Object.keys(response.fields)
                                .forEach((errorCode) => {
                                    setInputError(errorCode, response.fields[errorCode]);
                                });

                            try {
                                form.querySelectorAll('.is-invalid')[0].scrollIntoView({
                                    block: 'center',
                                    behavior: 'smooth',
                                });
                                // eslint-disable-next-line no-empty
                            } catch (ex) { }
                        }*/ else {
                            const errorTrigger = form.getAttribute(`data-trigger-on-${this.status}`);
                            if (errorTrigger) {
                                document.dispatchEvent(new CustomEvent(errorTrigger, {
                                    detail: cleanUpResponseData(response),
                                }));
                            } else {
                                // Other error
                                (async () => {
                                    await bootstrapConfirm({
                                        message: response.message || 'unknown',
                                        type: 'error',
                                        button: 'ok',
                                    });
                                })();
                            }
                        }

                        button.disabled = false;
                    }
                };
            });
        });
};

export default initAjaxForms;
